// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__JcV3K","question":"Question_question__1G41S","description":"Question_description__KZzlC"};